import { Component, inject, input, Input } from '@angular/core';
import { RealEstate } from '../../models/real-estate.model';
import { Router } from '@angular/router';
import { Plans } from '../../shared/constants/plan.constants';
import { Statuses } from '../../shared/constants/status.constants';

@Component({
  selector: 'app-property-item',
  standalone: false,
  templateUrl: './property-item.component.html',
  styleUrl: './property-item.component.scss',
})
export class PropertyItemComponent {
  @Input() property!: RealEstate;
  listId = input<string>('propertyList');

  private router = inject(Router);

  statuses = Statuses;
  plans = Plans;

  goToDetails(propertyId: number): void {
    this.router.navigate(['/properties', propertyId]);
  }

  isSponsered(): boolean {
    return this.property.isSponsered && new Date(this.property.sponseredExpireDate) > new Date();
  }
}
